import { render, staticRenderFns } from "./SignatureFooterSettings.vue?vue&type=template&id=177816cc&scoped=true"
import script from "./SignatureFooterSettings.vue?vue&type=script&lang=js"
export * from "./SignatureFooterSettings.vue?vue&type=script&lang=js"
import style0 from "./SignatureFooterSettings.vue?vue&type=style&index=0&id=177816cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177816cc",
  null
  
)

export default component.exports